import img_0 from '../../assets/hero-anim/images/img_0.png';
import img_1 from '../../assets/hero-anim/images/img_1.png';
import img_2 from '../../assets/hero-anim/images/img_2.png';
import img_3 from '../../assets/hero-anim/images/img_3.png';
import img_4 from '../../assets/hero-anim/images/img_4.png';
import img_5 from '../../assets/hero-anim/images/img_5.png';
import img_6 from '../../assets/hero-anim/images/img_6.png';
import img_7 from '../../assets/hero-anim/images/img_7.png';
import img_8 from '../../assets/hero-anim/images/img_8.png';
import img_9 from '../../assets/hero-anim/images/img_9.png';
import img_10 from '../../assets/hero-anim/images/img_10.png';
import img_11 from '../../assets/hero-anim/images/img_11.png';
import img_12 from '../../assets/hero-anim/images/img_12.png';
import img_13 from '../../assets/hero-anim/images/img_13.png';
import img_14 from '../../assets/hero-anim/images/img_14.png';

export default {
    "v": "5.9.0",
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 450.000018328876,
    "w": 2560,
    "h": 2880,
    "nm": "Final 3 File",
    "ddd": 0,
    "assets": [
        {
            "id": "image_0",
            "w": 849,
            "h": 212,
            "u": "",
            "p": img_0,
            "e": 0
        },
        {
            "id": "image_1",
            "w": 50,
            "h": 106,
            "u": "",
            "p": img_1,
            "e": 0
        },
        {
            "id": "image_2",
            "w": 69,
            "h": 55,
            "u": "",
            "p": img_2,
            "e": 0
        },
        {
            "id": "image_3",
            "w": 277,
            "h": 53,
            "u": "",
            "p": img_3,
            "e": 0
        },
        {
            "id": "image_4",
            "w": 48,
            "h": 48,
            "u": "",
            "p": img_4,
            "e": 0
        },
        {
            "id": "image_5",
            "w": 257,
            "h": 47,
            "u": "",
            "p": img_5,
            "e": 0
        },
        {
            "id": "image_6",
            "w": 49,
            "h": 49,
            "u": "",
            "p": img_6,
            "e": 0
        },
        {
            "id": "image_7",
            "w": 297,
            "h": 45,
            "u": "",
            "p": img_7,
            "e": 0
        },
        {
            "id": "image_8",
            "w": 57,
            "h": 44,
            "u": "",
            "p": img_8,
            "e": 0
        },
        {
            "id": "image_9",
            "w": 329,
            "h": 51,
            "u": "",
            "p": img_9,
            "e": 0
        },
        {
            "id": "image_10",
            "w": 56,
            "h": 67,
            "u": "",
            "p": img_10,
            "e": 0
        },
        {
            "id": "image_11",
            "w": 92,
            "h": 93,
            "u": "",
            "p": img_11,
            "e": 0
        },
        {
            "id": "image_12",
            "w": 103,
            "h": 78,
            "u": "",
            "p": img_12,
            "e": 0
        },
        {
            "id": "image_13",
            "w": 391,
            "h": 98,
            "u": "",
            "p": img_13,
            "e": 0
        },
        {
            "id": "image_14",
            "w": 314,
            "h": 98,
            "u": "",
            "p": img_14,
            "e": 0
        },
        {
            "id": "comp_0",
            "nm": "Arrows",
            "fr": 29.9700012207031,
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Shape Layer 113",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 483.000019672993,
                    "op": 487.000019835917,
                    "st": 988.000040242065,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Shape Layer 112",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 479.00001951007,
                    "op": 487.000019835917,
                    "st": 880.000035843135,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 4,
                    "nm": "Shape Layer 111",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 475.000019347147,
                    "op": 487.000019835917,
                    "st": 772.000031444205,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 4,
                    "ty": 4,
                    "nm": "Shape Layer 110",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 471.000019184223,
                    "op": 487.000019835917,
                    "st": 660.000026882351,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 5,
                    "ty": 4,
                    "nm": "Shape Layer 109",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 467.0000190213,
                    "op": 487.000019835917,
                    "st": 972.000039590372,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 6,
                    "ty": 4,
                    "nm": "Shape Layer 108",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 463.000018858377,
                    "op": 487.000019835917,
                    "st": 864.000035191441,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 7,
                    "ty": 4,
                    "nm": "Shape Layer 107",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 458.000018654722,
                    "op": 487.000019835917,
                    "st": 755.00003075178,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 8,
                    "ty": 4,
                    "nm": "Shape Layer 106",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 453.000018451068,
                    "op": 487.000019835917,
                    "st": 642.000026149196,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 9,
                    "ty": 4,
                    "nm": "Shape Layer 105",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 448.000018247414,
                    "op": 487.000019835917,
                    "st": 524.000021342958,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 10,
                    "ty": 4,
                    "nm": "Shape Layer 104",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 443.00001804376,
                    "op": 487.000019835917,
                    "st": 443.00001804376,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 11,
                    "ty": 4,
                    "nm": "Shape Layer 103",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 438.000017840106,
                    "op": 442.000018003029,
                    "st": 943.000038409177,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 12,
                    "ty": 4,
                    "nm": "Shape Layer 102",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 434.000017677182,
                    "op": 442.000018003029,
                    "st": 835.000034010247,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 13,
                    "ty": 4,
                    "nm": "Shape Layer 101",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 430.000017514259,
                    "op": 442.000018003029,
                    "st": 727.000029611317,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 14,
                    "ty": 4,
                    "nm": "Shape Layer 100",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 426.000017351336,
                    "op": 442.000018003029,
                    "st": 615.000025049463,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 15,
                    "ty": 4,
                    "nm": "Shape Layer 99",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 422.000017188412,
                    "op": 442.000018003029,
                    "st": 927.000037757484,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 16,
                    "ty": 4,
                    "nm": "Shape Layer 98",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 418.000017025489,
                    "op": 442.000018003029,
                    "st": 819.000033358554,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 17,
                    "ty": 4,
                    "nm": "Shape Layer 97",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 413.000016821835,
                    "op": 442.000018003029,
                    "st": 710.000028918893,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 18,
                    "ty": 4,
                    "nm": "Shape Layer 96",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 408.000016618181,
                    "op": 442.000018003029,
                    "st": 597.000024316308,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 19,
                    "ty": 4,
                    "nm": "Shape Layer 95",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 403.000016414526,
                    "op": 442.000018003029,
                    "st": 479.00001951007,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 20,
                    "ty": 4,
                    "nm": "Shape Layer 94",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 399.000016251603,
                    "op": 403.000016414527,
                    "st": 904.000036820675,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 21,
                    "ty": 4,
                    "nm": "Shape Layer 93",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 395.00001608868,
                    "op": 403.000016414526,
                    "st": 796.000032421745,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 22,
                    "ty": 4,
                    "nm": "Shape Layer 92",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 391.000015925756,
                    "op": 403.000016414526,
                    "st": 688.000028022814,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 23,
                    "ty": 4,
                    "nm": "Shape Layer 91",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 387.000015762833,
                    "op": 403.000016414527,
                    "st": 576.000023460961,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 24,
                    "ty": 4,
                    "nm": "Shape Layer 90",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 383.00001559991,
                    "op": 403.000016414526,
                    "st": 888.000036168982,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 25,
                    "ty": 4,
                    "nm": "Shape Layer 89",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 379.000015436986,
                    "op": 403.000016414526,
                    "st": 780.000031770051,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 26,
                    "ty": 4,
                    "nm": "Shape Layer 88",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 374.000015233332,
                    "op": 403.000016414527,
                    "st": 671.00002733039,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 27,
                    "ty": 4,
                    "nm": "Shape Layer 87",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 369.000015029678,
                    "op": 403.000016414526,
                    "st": 558.000022727806,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 28,
                    "ty": 4,
                    "nm": "Shape Layer 86",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 364.000014826024,
                    "op": 403.000016414526,
                    "st": 440.000017921567,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 29,
                    "ty": 4,
                    "nm": "Shape Layer 85",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 359.00001462237,
                    "op": 403.000016414527,
                    "st": 359.00001462237,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 30,
                    "ty": 4,
                    "nm": "Shape Layer 84",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 354.000014418716,
                    "op": 358.000014581639,
                    "st": 859.000034987787,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 31,
                    "ty": 4,
                    "nm": "Shape Layer 83",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 350.000014255792,
                    "op": 358.000014581639,
                    "st": 751.000030588857,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 32,
                    "ty": 4,
                    "nm": "Shape Layer 82",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 346.000014092869,
                    "op": 358.000014581639,
                    "st": 643.000026189927,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 33,
                    "ty": 4,
                    "nm": "Shape Layer 81",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 342.000013929946,
                    "op": 358.000014581639,
                    "st": 531.000021628073,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 34,
                    "ty": 4,
                    "nm": "Shape Layer 80",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 338.000013767022,
                    "op": 358.000014581639,
                    "st": 843.000034336094,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 35,
                    "ty": 4,
                    "nm": "Shape Layer 79",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 334.000013604099,
                    "op": 358.000014581639,
                    "st": 735.000029937164,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 36,
                    "ty": 4,
                    "nm": "Shape Layer 78",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 329.000013400445,
                    "op": 358.000014581639,
                    "st": 626.000025497503,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 37,
                    "ty": 4,
                    "nm": "Shape Layer 77",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 324.000013196791,
                    "op": 358.000014581639,
                    "st": 513.000020894918,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 38,
                    "ty": 4,
                    "nm": "Shape Layer 76",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 319.000012993136,
                    "op": 358.000014581639,
                    "st": 395.00001608868,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 39,
                    "ty": 4,
                    "nm": "Shape Layer 75",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 314.000012789482,
                    "op": 358.000014581639,
                    "st": 314.000012789482,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 40,
                    "ty": 4,
                    "nm": "Shape Layer 74",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 309.000012585828,
                    "op": 313.000012748751,
                    "st": 814.0000331549,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 41,
                    "ty": 4,
                    "nm": "Shape Layer 73",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 305.000012422905,
                    "op": 313.000012748751,
                    "st": 706.00002875597,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 42,
                    "ty": 4,
                    "nm": "Shape Layer 72",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 301.000012259981,
                    "op": 313.000012748751,
                    "st": 598.000024357039,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 43,
                    "ty": 4,
                    "nm": "Shape Layer 71",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 297.000012097058,
                    "op": 313.000012748751,
                    "st": 486.000019795186,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 44,
                    "ty": 4,
                    "nm": "Shape Layer 70",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 293.000011934135,
                    "op": 313.000012748751,
                    "st": 798.000032503206,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 45,
                    "ty": 4,
                    "nm": "Shape Layer 69",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 289.000011771211,
                    "op": 313.000012748751,
                    "st": 690.000028104276,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 46,
                    "ty": 4,
                    "nm": "Shape Layer 68",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 284.000011567557,
                    "op": 313.000012748751,
                    "st": 581.000023664615,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 47,
                    "ty": 4,
                    "nm": "Shape Layer 67",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 279.000011363903,
                    "op": 313.000012748751,
                    "st": 468.000019062031,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 48,
                    "ty": 4,
                    "nm": "Shape Layer 66",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 274.000011160249,
                    "op": 313.000012748751,
                    "st": 350.000014255792,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 49,
                    "ty": 4,
                    "nm": "Shape Layer 65",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 269.000010956595,
                    "op": 313.000012748751,
                    "st": 269.000010956595,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 50,
                    "ty": 4,
                    "nm": "Shape Layer 64",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 264.00001075294,
                    "op": 268.000010915864,
                    "st": 769.000031322012,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 51,
                    "ty": 4,
                    "nm": "Shape Layer 63",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 260.000010590017,
                    "op": 268.000010915864,
                    "st": 661.000026923082,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 52,
                    "ty": 4,
                    "nm": "Shape Layer 62",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 256.000010427094,
                    "op": 268.000010915864,
                    "st": 553.000022524152,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 53,
                    "ty": 4,
                    "nm": "Shape Layer 61",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 252.00001026417,
                    "op": 268.000010915864,
                    "st": 441.000017962298,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 54,
                    "ty": 4,
                    "nm": "Shape Layer 60",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 248.000010101247,
                    "op": 268.000010915864,
                    "st": 753.000030670319,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 55,
                    "ty": 4,
                    "nm": "Shape Layer 59",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 244.000009938324,
                    "op": 268.000010915864,
                    "st": 645.000026271389,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 56,
                    "ty": 4,
                    "nm": "Shape Layer 58",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 239.00000973467,
                    "op": 268.000010915864,
                    "st": 536.000021831728,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 57,
                    "ty": 4,
                    "nm": "Shape Layer 57",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 234.000009531015,
                    "op": 268.000010915864,
                    "st": 423.000017229143,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 58,
                    "ty": 4,
                    "nm": "Shape Layer 56",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 229.000009327361,
                    "op": 268.000010915864,
                    "st": 305.000012422905,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 59,
                    "ty": 4,
                    "nm": "Shape Layer 55",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 225.000009164438,
                    "op": 229.000009327361,
                    "st": 730.00002973351,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 60,
                    "ty": 4,
                    "nm": "Shape Layer 54",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 221.000009001515,
                    "op": 229.000009327361,
                    "st": 622.000025334579,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 61,
                    "ty": 4,
                    "nm": "Shape Layer 53",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 217.000008838591,
                    "op": 229.000009327361,
                    "st": 514.000020935649,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 62,
                    "ty": 4,
                    "nm": "Shape Layer 52",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 213.000008675668,
                    "op": 229.000009327361,
                    "st": 402.000016373796,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 63,
                    "ty": 4,
                    "nm": "Shape Layer 51",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 209.000008512745,
                    "op": 229.000009327361,
                    "st": 714.000029081816,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 64,
                    "ty": 4,
                    "nm": "Shape Layer 50",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 205.000008349821,
                    "op": 229.000009327361,
                    "st": 606.000024682886,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 65,
                    "ty": 4,
                    "nm": "Shape Layer 49",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 200.000008146167,
                    "op": 229.000009327361,
                    "st": 497.000020243225,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 66,
                    "ty": 4,
                    "nm": "Shape Layer 48",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 195.000007942513,
                    "op": 229.000009327361,
                    "st": 384.000015640641,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 67,
                    "ty": 4,
                    "nm": "Shape Layer 47",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 190.000007738859,
                    "op": 229.000009327361,
                    "st": 266.000010834402,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 68,
                    "ty": 4,
                    "nm": "Shape Layer 46",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 185.000007535204,
                    "op": 229.000009327361,
                    "st": 185.000007535204,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 69,
                    "ty": 4,
                    "nm": "Shape Layer 45",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 180.00000733155,
                    "op": 184.000007494474,
                    "st": 685.000027900622,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 70,
                    "ty": 4,
                    "nm": "Shape Layer 44",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 176.000007168627,
                    "op": 184.000007494474,
                    "st": 577.000023501692,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 71,
                    "ty": 4,
                    "nm": "Shape Layer 43",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 172.000007005704,
                    "op": 184.000007494474,
                    "st": 469.000019102762,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 72,
                    "ty": 4,
                    "nm": "Shape Layer 42",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 168.00000684278,
                    "op": 184.000007494474,
                    "st": 357.000014540908,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 73,
                    "ty": 4,
                    "nm": "Shape Layer 41",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 164.000006679857,
                    "op": 184.000007494474,
                    "st": 669.000027248929,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 74,
                    "ty": 4,
                    "nm": "Shape Layer 40",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 160.000006516934,
                    "op": 184.000007494474,
                    "st": 561.000022849998,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 75,
                    "ty": 4,
                    "nm": "Shape Layer 39",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 155.000006313279,
                    "op": 184.000007494474,
                    "st": 452.000018410337,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 76,
                    "ty": 4,
                    "nm": "Shape Layer 38",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 150.000006109625,
                    "op": 184.000007494474,
                    "st": 339.000013807753,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 77,
                    "ty": 4,
                    "nm": "Shape Layer 37",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 145.000005905971,
                    "op": 184.000007494474,
                    "st": 221.000009001515,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 78,
                    "ty": 4,
                    "nm": "Shape Layer 36",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 140.000005702317,
                    "op": 184.000007494474,
                    "st": 140.000005702317,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 79,
                    "ty": 4,
                    "nm": "Shape Layer 35",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 135.000005498663,
                    "op": 139.000005661586,
                    "st": 640.000026067734,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 80,
                    "ty": 4,
                    "nm": "Shape Layer 34",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 131.000005335739,
                    "op": 139.000005661586,
                    "st": 532.000021668804,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 81,
                    "ty": 4,
                    "nm": "Shape Layer 33",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 127.000005172816,
                    "op": 139.000005661586,
                    "st": 424.000017269874,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 82,
                    "ty": 4,
                    "nm": "Shape Layer 32",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 123.000005009893,
                    "op": 139.000005661586,
                    "st": 312.000012708021,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 83,
                    "ty": 4,
                    "nm": "Shape Layer 31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 119.000004846969,
                    "op": 139.000005661586,
                    "st": 624.000025416041,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 84,
                    "ty": 4,
                    "nm": "Shape Layer 30",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 115.000004684046,
                    "op": 139.000005661586,
                    "st": 516.000021017111,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 85,
                    "ty": 4,
                    "nm": "Shape Layer 29",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 110.000004480392,
                    "op": 139.000005661586,
                    "st": 407.00001657745,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 86,
                    "ty": 4,
                    "nm": "Shape Layer 28",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 105.000004276738,
                    "op": 139.000005661586,
                    "st": 294.000011974866,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 87,
                    "ty": 4,
                    "nm": "Shape Layer 27",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 100.000004073084,
                    "op": 139.000005661586,
                    "st": 176.000007168627,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 88,
                    "ty": 4,
                    "nm": "Shape Layer 26",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 95.0000038694293,
                    "op": 139.000005661586,
                    "st": 95.0000038694293,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 89,
                    "ty": 4,
                    "nm": "Shape Layer 25",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 89.0000036250443,
                    "op": 93.0000037879677,
                    "st": 594.000024194116,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 90,
                    "ty": 4,
                    "nm": "Shape Layer 24",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 85.000003462121,
                    "op": 93.0000037879676,
                    "st": 486.000019795186,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 91,
                    "ty": 4,
                    "nm": "Shape Layer 23",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 81.0000032991976,
                    "op": 93.0000037879676,
                    "st": 378.000015396256,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 92,
                    "ty": 4,
                    "nm": "Shape Layer 22",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 77.0000031362743,
                    "op": 93.0000037879676,
                    "st": 266.000010834402,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 93,
                    "ty": 4,
                    "nm": "Shape Layer 21",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 73.000002973351,
                    "op": 93.0000037879677,
                    "st": 578.000023542423,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 94,
                    "ty": 4,
                    "nm": "Shape Layer 20",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 69.0000028104276,
                    "op": 93.0000037879677,
                    "st": 470.000019143492,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 95,
                    "ty": 4,
                    "nm": "Shape Layer 19",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 64.0000026067734,
                    "op": 93.0000037879676,
                    "st": 361.000014703831,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 96,
                    "ty": 4,
                    "nm": "Shape Layer 18",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 59.0000024031193,
                    "op": 93.0000037879676,
                    "st": 248.000010101247,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 97,
                    "ty": 4,
                    "nm": "Shape Layer 17",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 54.0000021994651,
                    "op": 93.0000037879676,
                    "st": 130.000005295009,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 98,
                    "ty": 4,
                    "nm": "Shape Layer 16",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 49.0000019958109,
                    "op": 93.0000037879676,
                    "st": 49.0000019958109,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 99,
                    "ty": 4,
                    "nm": "Shape Layer 15",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                6,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 40.0000016292334,
                    "op": 44.0000017921567,
                    "st": 545.000022198305,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 100,
                    "ty": 4,
                    "nm": "Shape Layer 14",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                11.625,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 36.0000014663101,
                    "op": 44.0000017921567,
                    "st": 437.000017799375,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 101,
                    "ty": 4,
                    "nm": "Shape Layer 13",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17.25,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 32.0000013033867,
                    "op": 44.0000017921567,
                    "st": 329.000013400445,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 102,
                    "ty": 4,
                    "nm": "Shape Layer 12",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                22.875,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 28.0000011404634,
                    "op": 44.0000017921567,
                    "st": 217.000008838591,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 103,
                    "ty": 4,
                    "nm": "Shape Layer 11",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                27.562,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 24.00000097754,
                    "op": 44.0000017921567,
                    "st": 529.000021546612,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 104,
                    "ty": 4,
                    "nm": "Shape Layer 10",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                33.188,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 20.0000008146167,
                    "op": 44.0000017921567,
                    "st": 421.000017147681,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 105,
                    "ty": 4,
                    "nm": "Shape Layer 9",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                38.812,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 15.0000006109625,
                    "op": 44.0000017921567,
                    "st": 312.000012708021,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 106,
                    "ty": 4,
                    "nm": "Shape Layer 8",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                44.438,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 10.0000004073083,
                    "op": 44.0000017921567,
                    "st": 199.000008105436,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 107,
                    "ty": 4,
                    "nm": "Shape Layer 7",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                50.062,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 5.00000020365417,
                    "op": 44.0000017921567,
                    "st": 81.0000032991976,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 108,
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.688,
                                7.031,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                26.688,
                                0.031,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29,
                                                    -6.875
                                                ],
                                                [
                                                    24.375,
                                                    0.375
                                                ],
                                                [
                                                    29,
                                                    6.938
                                                ]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1,
                                            1
                                        ],
                                        "ix": 3
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 4
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1,
                                        "ix": 5
                                    },
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Shape 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 44.0000017921567,
                    "st": 0,
                    "bm": 0
                }
            ]
        }
    ],
    "fonts": {
        "list": [
            {
                "fName": "Inter-Regular",
                "fFamily": "Inter",
                "fStyle": "Regular",
                "ascent": 72.7264404296875
            }
        ]
    },
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 2,
            "nm": "Logo.ai",
            "cl": "ai",
            "refId": "image_0",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 35,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1280,
                        305,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        424.5,
                        106,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        130.189,
                        130.189,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 610.000024845809,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 0,
            "nm": "Arrows",
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 180,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1161.848,
                        1622.48,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        29,
                        7,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        258.182,
                        258.182,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "w": 58,
            "h": 14,
            "ip": 117.000004765508,
            "op": 3713.00015123359,
            "st": 117.000004765508,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 0,
            "nm": "Arrows",
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 180,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1684.598,
                        1419.48,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        29,
                        7,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        258.182,
                        258.182,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "w": 58,
            "h": 14,
            "ip": 117.000004765508,
            "op": 3713.00015123359,
            "st": 117.000004765508,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 0,
            "nm": "Arrows",
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        896.25,
                        1370.75,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        29,
                        7,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        258.182,
                        258.182,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "w": 58,
            "h": 14,
            "ip": 113.000004602584,
            "op": 3709.00015107067,
            "st": 113.000004602584,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Shape Layer 2",
            "td": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1477.25,
                        1220,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        169.5,
                        -132,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            144.5,
                                            -78
                                        ],
                                        [
                                            144.5,
                                            -186
                                        ],
                                        [
                                            194.5,
                                            -186
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 0,
                                "k": 0,
                                "ix": 1
                            },
                            "e": {
                                "a": 0,
                                "k": 100,
                                "ix": 2
                            },
                            "o": {
                                "a": 0,
                                "k": 0,
                                "ix": 3
                            },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 8,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 0,
                        "k": 0,
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 26,
                                "s": [
                                    0
                                ]
                            },
                            {
                                "t": 106.000004317469,
                                "s": [
                                    100
                                ]
                            }
                        ],
                        "ix": 2
                    },
                    "o": {
                        "a": 0,
                        "k": 0,
                        "ix": 3
                    },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 26.0000010590017,
            "op": 457.000018613992,
            "st": 26.0000010590017,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 2,
            "nm": "Training Arrow.png",
            "cl": "png",
            "tt": 1,
            "refId": "image_1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1476.5,
                        1209.75,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        25,
                        53,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 2,
            "nm": "Training Icon.png",
            "cl": "png",
            "refId": "image_2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 102,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 105.000004276738,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1618.75,
                        1107.33,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        34.5,
                        27.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Wiggle - position",
                    "np": 4,
                    "mn": "ADBE CM WigglePosition",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Wiggle Speed (wigs/sec)",
                            "mn": "ADBE CM WigglePosition-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 1
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Wiggle Amount (pixels)",
                            "mn": "ADBE CM WigglePosition-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": 3,
                                "ix": 2
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "(Transform)",
                    "np": 14,
                    "mn": "ADBE Geometry2",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 3,
                            "nm": "Anchor Point",
                            "mn": "ADBE Geometry2-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            }
                        },
                        {
                            "ty": 3,
                            "nm": "Position",
                            "mn": "ADBE Geometry2-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2,
                                "x": "var $bm_rt;\n$bm_rt = wiggle(effect('Wiggle - position')('Wiggle Speed (wigs/sec)'), effect('Wiggle - position')('Wiggle Amount (pixels)'));"
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Uniform Scale",
                            "mn": "ADBE Geometry2-0011",
                            "ix": 3,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 3
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Height",
                            "mn": "ADBE Geometry2-0003",
                            "ix": 4,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Width",
                            "mn": "ADBE Geometry2-0004",
                            "ix": 5,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew",
                            "mn": "ADBE Geometry2-0005",
                            "ix": 6,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew Axis",
                            "mn": "ADBE Geometry2-0006",
                            "ix": 7,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 7
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Rotation",
                            "mn": "ADBE Geometry2-0007",
                            "ix": 8,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 8
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Opacity",
                            "mn": "ADBE Geometry2-0008",
                            "ix": 9,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 9
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Use Composition’s Shutter Angle",
                            "mn": "ADBE Geometry2-0009",
                            "ix": 10,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 10
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Shutter Angle",
                            "mn": "ADBE Geometry2-0010",
                            "ix": 11,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 11
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Sampling",
                            "mn": "ADBE Geometry2-0012",
                            "ix": 12,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 12
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Sharpen",
                    "np": 3,
                    "mn": "ADBE Sharpen",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Sharpen Amount",
                            "mn": "ADBE Sharpen-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 5,
            "nm": "TRAINING",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 102,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 105.000004276738,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1849.002,
                        1107.33,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        59.002,
                        -9.091,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 25,
                                "f": "Inter-Regular",
                                "t": "TRAINING",
                                "ca": 0,
                                "j": 0,
                                "tr": 0,
                                "lh": 30.0000019073486,
                                "ls": 0,
                                "fc": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": {
                    "g": 1,
                    "a": {
                        "a": 0,
                        "k": [
                            0,
                            0
                        ],
                        "ix": 2
                    }
                },
                "a": []
            },
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "Shape Layer 3",
            "td": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1884.875,
                        1325,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        437.875,
                        -64,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            298,
                                            -39
                                        ],
                                        [
                                            400.75,
                                            -39
                                        ],
                                        [
                                            400.75,
                                            -89
                                        ],
                                        [
                                            577.75,
                                            -89
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 0,
                                "k": 0,
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0
                                            ]
                                        },
                                        "t": 3,
                                        "s": [
                                            0
                                        ]
                                    },
                                    {
                                        "t": 53.0000021587343,
                                        "s": [
                                            100
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "o": {
                                "a": 0,
                                "k": 0,
                                "ix": 3
                            },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 8,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 3.00000012219251,
            "op": 457.000018613992,
            "st": 3.00000012219251,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 11,
            "ty": 2,
            "nm": "TECHNOLOGY Arrow.png",
            "cl": "png",
            "tt": 1,
            "refId": "image_3",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1885.5,
                        1324.5,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        138.5,
                        26.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 12,
            "ty": 2,
            "nm": "TECHNOLOGY Icon.png",
            "cl": "png",
            "refId": "image_4",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 50,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 53.0000021587343,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        2248,
                        1261,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        24,
                        24,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Wiggle - position",
                    "np": 4,
                    "mn": "ADBE CM WigglePosition",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Wiggle Speed (wigs/sec)",
                            "mn": "ADBE CM WigglePosition-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 1
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Wiggle Amount (pixels)",
                            "mn": "ADBE CM WigglePosition-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": 5,
                                "ix": 2
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "(Transform)",
                    "np": 14,
                    "mn": "ADBE Geometry2",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 3,
                            "nm": "Anchor Point",
                            "mn": "ADBE Geometry2-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            }
                        },
                        {
                            "ty": 3,
                            "nm": "Position",
                            "mn": "ADBE Geometry2-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2,
                                "x": "var $bm_rt;\n$bm_rt = wiggle(effect('Wiggle - position')('Wiggle Speed (wigs/sec)'), effect('Wiggle - position')('Wiggle Amount (pixels)'));"
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Uniform Scale",
                            "mn": "ADBE Geometry2-0011",
                            "ix": 3,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 3
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Height",
                            "mn": "ADBE Geometry2-0003",
                            "ix": 4,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Width",
                            "mn": "ADBE Geometry2-0004",
                            "ix": 5,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew",
                            "mn": "ADBE Geometry2-0005",
                            "ix": 6,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew Axis",
                            "mn": "ADBE Geometry2-0006",
                            "ix": 7,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 7
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Rotation",
                            "mn": "ADBE Geometry2-0007",
                            "ix": 8,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 8
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Opacity",
                            "mn": "ADBE Geometry2-0008",
                            "ix": 9,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 9
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Use Composition’s Shutter Angle",
                            "mn": "ADBE Geometry2-0009",
                            "ix": 10,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 10
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Shutter Angle",
                            "mn": "ADBE Geometry2-0010",
                            "ix": 11,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 11
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Sampling",
                            "mn": "ADBE Geometry2-0012",
                            "ix": 12,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 12
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Sharpen",
                    "np": 3,
                    "mn": "ADBE Sharpen",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Sharpen Amount",
                            "mn": "ADBE Sharpen-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 30,
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 13,
            "ty": 5,
            "nm": "TECHNOLOGY",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 50,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 53.0000021587343,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        2025.784,
                        1348.159,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0.284,
                        -9.091,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 25,
                                "f": "Inter-Regular",
                                "t": "TECHNOLOGY",
                                "ca": 0,
                                "j": 2,
                                "tr": 0,
                                "lh": 30.0000019073486,
                                "ls": 0,
                                "fc": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": {
                    "g": 1,
                    "a": {
                        "a": 0,
                        "k": [
                            0,
                            0
                        ],
                        "ix": 2
                    }
                },
                "a": []
            },
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 15,
            "ty": 4,
            "nm": "Shape Layer 7",
            "td": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        722,
                        1559.625,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        -442,
                        -16.375,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -313,
                                            -38.25
                                        ],
                                        [
                                            -571,
                                            -38.25
                                        ],
                                        [
                                            -571,
                                            5.5
                                        ],
                                        [
                                            -551.5,
                                            5.5
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 8,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 0,
                        "k": 0,
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 20,
                                "s": [
                                    0
                                ]
                            },
                            {
                                "t": 105.000004276738,
                                "s": [
                                    100
                                ]
                            }
                        ],
                        "ix": 2
                    },
                    "o": {
                        "a": 0,
                        "k": 0,
                        "ix": 3
                    },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 20.0000008146167,
            "op": 457.000018613992,
            "st": 20.0000008146167,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 16,
            "ty": 2,
            "nm": "Strategy Arrow.png",
            "cl": "png",
            "tt": 1,
            "refId": "image_5",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        720.688,
                        1559.875,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        128.5,
                        23.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 17,
            "ty": 2,
            "nm": "Strategy Icon.png",
            "cl": "png",
            "refId": "image_6",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 101,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 104.000004236007,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        578.25,
                        1601.25,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        24.5,
                        24.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Wiggle - position",
                    "np": 4,
                    "mn": "ADBE CM WigglePosition",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Wiggle Speed (wigs/sec)",
                            "mn": "ADBE CM WigglePosition-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 1
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Wiggle Amount (pixels)",
                            "mn": "ADBE CM WigglePosition-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": 5,
                                "ix": 2
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "(Transform)",
                    "np": 14,
                    "mn": "ADBE Geometry2",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 3,
                            "nm": "Anchor Point",
                            "mn": "ADBE Geometry2-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            }
                        },
                        {
                            "ty": 3,
                            "nm": "Position",
                            "mn": "ADBE Geometry2-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2,
                                "x": "var $bm_rt;\n$bm_rt = wiggle(effect('Wiggle - position')('Wiggle Speed (wigs/sec)'), effect('Wiggle - position')('Wiggle Amount (pixels)'));"
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Uniform Scale",
                            "mn": "ADBE Geometry2-0011",
                            "ix": 3,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 3
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Height",
                            "mn": "ADBE Geometry2-0003",
                            "ix": 4,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Width",
                            "mn": "ADBE Geometry2-0004",
                            "ix": 5,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew",
                            "mn": "ADBE Geometry2-0005",
                            "ix": 6,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew Axis",
                            "mn": "ADBE Geometry2-0006",
                            "ix": 7,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 7
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Rotation",
                            "mn": "ADBE Geometry2-0007",
                            "ix": 8,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 8
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Opacity",
                            "mn": "ADBE Geometry2-0008",
                            "ix": 9,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 9
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Use Composition’s Shutter Angle",
                            "mn": "ADBE Geometry2-0009",
                            "ix": 10,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 10
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Shutter Angle",
                            "mn": "ADBE Geometry2-0010",
                            "ix": 11,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 11
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Sampling",
                            "mn": "ADBE Geometry2-0012",
                            "ix": 12,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 12
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Sharpen",
                    "np": 3,
                    "mn": "ADBE Sharpen",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Sharpen Amount",
                            "mn": "ADBE Sharpen-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 30,
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 18,
            "ty": 5,
            "nm": "STRATEGY",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 101,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 104.000004236007,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        776.327,
                        1603.195,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        64.577,
                        -9.055,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 25,
                                "f": "Inter-Regular",
                                "t": "STRATEGY",
                                "ca": 0,
                                "j": 0,
                                "tr": 0,
                                "lh": 30.0000019073486,
                                "ls": 0,
                                "fc": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": {
                    "g": 1,
                    "a": {
                        "a": 0,
                        "k": [
                            0,
                            0
                        ],
                        "ix": 2
                    }
                },
                "a": []
            },
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 20,
            "ty": 4,
            "nm": "Shape Layer 6",
            "td": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": -90,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1098.75,
                        1895,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        -425.25,
                        123,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -276,
                                            100.5
                                        ],
                                        [
                                            -574.5,
                                            100.5
                                        ],
                                        [
                                            -574.5,
                                            145.5
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 8,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 0,
                        "k": 0,
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": {
                                    "x": [
                                        0.833
                                    ],
                                    "y": [
                                        0.833
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.167
                                    ],
                                    "y": [
                                        0.167
                                    ]
                                },
                                "t": 3,
                                "s": [
                                    0
                                ]
                            },
                            {
                                "t": 53.0000021587343,
                                "s": [
                                    100
                                ]
                            }
                        ],
                        "ix": 2
                    },
                    "o": {
                        "a": 0,
                        "k": 0,
                        "ix": 3
                    },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 3.00000012219251,
            "op": 457.000018613992,
            "st": 3.00000012219251,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 21,
            "ty": 2,
            "nm": "JOB PLACEMENT SUPPORT Arrow.png",
            "cl": "png",
            "tt": 1,
            "refId": "image_7",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": -90,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1095.5,
                        1902,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        148.5,
                        22.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": -36.0000014663101,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 22,
            "ty": 2,
            "nm": "JOB PLACEMENT SUPPORT Icon.png",
            "cl": "png",
            "refId": "image_8",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 49,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 52.0000021180034,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1226,
                        2178,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        28.5,
                        22,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Wiggle - position",
                    "np": 4,
                    "mn": "ADBE CM WigglePosition",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Wiggle Speed (wigs/sec)",
                            "mn": "ADBE CM WigglePosition-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 1
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Wiggle Amount (pixels)",
                            "mn": "ADBE CM WigglePosition-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": 3,
                                "ix": 2
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "(Transform)",
                    "np": 14,
                    "mn": "ADBE Geometry2",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 3,
                            "nm": "Anchor Point",
                            "mn": "ADBE Geometry2-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            }
                        },
                        {
                            "ty": 3,
                            "nm": "Position",
                            "mn": "ADBE Geometry2-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2,
                                "x": "var $bm_rt;\n$bm_rt = wiggle(effect('Wiggle - position')('Wiggle Speed (wigs/sec)'), effect('Wiggle - position')('Wiggle Amount (pixels)'));"
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Uniform Scale",
                            "mn": "ADBE Geometry2-0011",
                            "ix": 3,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 3
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Height",
                            "mn": "ADBE Geometry2-0003",
                            "ix": 4,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Width",
                            "mn": "ADBE Geometry2-0004",
                            "ix": 5,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew",
                            "mn": "ADBE Geometry2-0005",
                            "ix": 6,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew Axis",
                            "mn": "ADBE Geometry2-0006",
                            "ix": 7,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 7
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Rotation",
                            "mn": "ADBE Geometry2-0007",
                            "ix": 8,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 8
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Opacity",
                            "mn": "ADBE Geometry2-0008",
                            "ix": 9,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 9
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Use Composition’s Shutter Angle",
                            "mn": "ADBE Geometry2-0009",
                            "ix": 10,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 10
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Shutter Angle",
                            "mn": "ADBE Geometry2-0010",
                            "ix": 11,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 11
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Sampling",
                            "mn": "ADBE Geometry2-0012",
                            "ix": 12,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 12
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Sharpen",
                    "np": 3,
                    "mn": "ADBE Sharpen",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Sharpen Amount",
                            "mn": "ADBE Sharpen-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 30,
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 457.000018613992,
            "st": -36.0000014663101,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 23,
            "ty": 5,
            "nm": "JOB PLACEMENT SUPPORT",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 49,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 52.0000021180034,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1532.013,
                        2173.195,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        104.013,
                        5.945,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 25,
                                "f": "Inter-Regular",
                                "t": "JOB PLACEMENT\rSUPPORT",
                                "ca": 0,
                                "j": 0,
                                "tr": 0,
                                "lh": 30.0000019073486,
                                "ls": 0,
                                "fc": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": {
                    "g": 1,
                    "a": {
                        "a": 0,
                        "k": [
                            0,
                            0
                        ],
                        "ix": 2
                    }
                },
                "a": []
            },
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 25,
            "ty": 4,
            "nm": "Shape Layer 4",
            "td": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1899.75,
                        1586,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        442.75,
                        120,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            276.5,
                                            96.5
                                        ],
                                        [
                                            609,
                                            96.5
                                        ],
                                        [
                                            609,
                                            143.5
                                        ],
                                        [
                                            583,
                                            143.5
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 8,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 0,
                        "k": 0,
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 20,
                                "s": [
                                    0
                                ]
                            },
                            {
                                "t": 105.000004276738,
                                "s": [
                                    100
                                ]
                            }
                        ],
                        "ix": 2
                    },
                    "o": {
                        "a": 0,
                        "k": 0,
                        "ix": 3
                    },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 20.0000008146167,
            "op": 457.000018613992,
            "st": 20.0000008146167,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 26,
            "ty": 2,
            "nm": "INNOVATION Icon-1.png",
            "cl": "png",
            "tt": 1,
            "refId": "image_9",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1901,
                        1586.5,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        164.5,
                        25.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 27,
            "ty": 2,
            "nm": "INNOVATION Icon.png",
            "cl": "png",
            "refId": "image_10",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 96,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 99.0000040323527,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        2101,
                        1647,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        28,
                        33.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Wiggle - position",
                    "np": 4,
                    "mn": "ADBE CM WigglePosition",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Wiggle Speed (wigs/sec)",
                            "mn": "ADBE CM WigglePosition-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 1
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Wiggle Amount (pixels)",
                            "mn": "ADBE CM WigglePosition-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": 3,
                                "ix": 2
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "(Transform)",
                    "np": 14,
                    "mn": "ADBE Geometry2",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 3,
                            "nm": "Anchor Point",
                            "mn": "ADBE Geometry2-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            }
                        },
                        {
                            "ty": 3,
                            "nm": "Position",
                            "mn": "ADBE Geometry2-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2,
                                "x": "var $bm_rt;\n$bm_rt = wiggle(effect('Wiggle - position')('Wiggle Speed (wigs/sec)'), effect('Wiggle - position')('Wiggle Amount (pixels)'));"
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Uniform Scale",
                            "mn": "ADBE Geometry2-0011",
                            "ix": 3,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 3
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Height",
                            "mn": "ADBE Geometry2-0003",
                            "ix": 4,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Width",
                            "mn": "ADBE Geometry2-0004",
                            "ix": 5,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew",
                            "mn": "ADBE Geometry2-0005",
                            "ix": 6,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew Axis",
                            "mn": "ADBE Geometry2-0006",
                            "ix": 7,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 7
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Rotation",
                            "mn": "ADBE Geometry2-0007",
                            "ix": 8,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 8
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Opacity",
                            "mn": "ADBE Geometry2-0008",
                            "ix": 9,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 9
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Use Composition’s Shutter Angle",
                            "mn": "ADBE Geometry2-0009",
                            "ix": 10,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 10
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Shutter Angle",
                            "mn": "ADBE Geometry2-0010",
                            "ix": 11,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 11
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Sampling",
                            "mn": "ADBE Geometry2-0012",
                            "ix": 12,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 12
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Sharpen",
                    "np": 3,
                    "mn": "ADBE Sharpen",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Sharpen Amount",
                            "mn": "ADBE Sharpen-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 30,
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 28,
            "ty": 5,
            "nm": "INNOVATION",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 96,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 99.0000040323527,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1851.527,
                        1651.409,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        76.527,
                        -9.091,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 25,
                                "f": "Inter-Regular",
                                "t": "INNOVATION",
                                "ca": 0,
                                "j": 0,
                                "tr": 0,
                                "lh": 30.0000019073486,
                                "ls": 0,
                                "fc": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": {
                    "g": 1,
                    "a": {
                        "a": 0,
                        "k": [
                            0,
                            0
                        ],
                        "ix": 2
                    }
                },
                "a": []
            },
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 31,
            "ty": 4,
            "nm": "Shape Layer 1",
            "td": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 90,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1097,
                        1225,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        -153,
                        -115,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        -223.656,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -107,
                                            -68.5
                                        ],
                                        [
                                            -199,
                                            -68.5
                                        ],
                                        [
                                            -199,
                                            -161.5
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 8,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 0,
                        "k": 0,
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 3,
                                "s": [
                                    0
                                ]
                            },
                            {
                                "t": 53.0000021587343,
                                "s": [
                                    100
                                ]
                            }
                        ],
                        "ix": 2
                    },
                    "o": {
                        "a": 0,
                        "k": 0,
                        "ix": 3
                    },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 3.00000012219251,
            "op": 457.000018613992,
            "st": 3.00000012219251,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 32,
            "ty": 2,
            "nm": "CLOUD Certification Arrow.png",
            "cl": "png",
            "tt": 1,
            "refId": "image_11",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 90,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1098.5,
                        1219,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        46,
                        46.5,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        -223.656,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 33,
            "ty": 2,
            "nm": "CLOUD Certification Icon.png",
            "cl": "png",
            "refId": "image_12",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 47,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 50.0000020365418,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        882.062,
                        1130.312,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        51.5,
                        39,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Wiggle - position",
                    "np": 4,
                    "mn": "ADBE CM WigglePosition",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Wiggle Speed (wigs/sec)",
                            "mn": "ADBE CM WigglePosition-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 1
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Wiggle Amount (pixels)",
                            "mn": "ADBE CM WigglePosition-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": 3,
                                "ix": 2
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "(Transform)",
                    "np": 14,
                    "mn": "ADBE Geometry2",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 3,
                            "nm": "Anchor Point",
                            "mn": "ADBE Geometry2-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            }
                        },
                        {
                            "ty": 3,
                            "nm": "Position",
                            "mn": "ADBE Geometry2-0002",
                            "ix": 2,
                            "v": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2,
                                "x": "var $bm_rt;\n$bm_rt = wiggle(effect('Wiggle - position')('Wiggle Speed (wigs/sec)'), effect('Wiggle - position')('Wiggle Amount (pixels)'));"
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Uniform Scale",
                            "mn": "ADBE Geometry2-0011",
                            "ix": 3,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 3
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Height",
                            "mn": "ADBE Geometry2-0003",
                            "ix": 4,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Scale Width",
                            "mn": "ADBE Geometry2-0004",
                            "ix": 5,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew",
                            "mn": "ADBE Geometry2-0005",
                            "ix": 6,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Skew Axis",
                            "mn": "ADBE Geometry2-0006",
                            "ix": 7,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 7
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Rotation",
                            "mn": "ADBE Geometry2-0007",
                            "ix": 8,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 8
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Opacity",
                            "mn": "ADBE Geometry2-0008",
                            "ix": 9,
                            "v": {
                                "a": 0,
                                "k": 100,
                                "ix": 9
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Use Composition’s Shutter Angle",
                            "mn": "ADBE Geometry2-0009",
                            "ix": 10,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 10
                            }
                        },
                        {
                            "ty": 0,
                            "nm": "Shutter Angle",
                            "mn": "ADBE Geometry2-0010",
                            "ix": 11,
                            "v": {
                                "a": 0,
                                "k": 0,
                                "ix": 11
                            }
                        },
                        {
                            "ty": 7,
                            "nm": "Sampling",
                            "mn": "ADBE Geometry2-0012",
                            "ix": 12,
                            "v": {
                                "a": 0,
                                "k": 1,
                                "ix": 12
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Sharpen",
                    "np": 3,
                    "mn": "ADBE Sharpen",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Sharpen Amount",
                            "mn": "ADBE Sharpen-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": 20,
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 47.0000019143492,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 34,
            "ty": 5,
            "nm": "CLOUD CERTIFICATE",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833
                                ],
                                "y": [
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 47,
                            "s": [
                                0
                            ]
                        },
                        {
                            "t": 50.0000020365418,
                            "s": [
                                100
                            ]
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        518.739,
                        1115.391,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0.239,
                        -7.109,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        200,
                        200,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 25,
                                "f": "Inter-Regular",
                                "t": "CLOUD CERTIFICATE",
                                "ca": 0,
                                "j": 2,
                                "tr": 0,
                                "lh": 30.0000019073486,
                                "ls": 0,
                                "fc": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": {
                    "g": 1,
                    "a": {
                        "a": 0,
                        "k": [
                            0,
                            0
                        ],
                        "ix": 2
                    }
                },
                "a": []
            },
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 37,
            "ty": 2,
            "nm": "DoubleDigit 2",
            "refId": "image_13",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1280,
                        1385.12,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        195.5,
                        49,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            "t": 33,
                            "s": [
                                148.814,
                                148.814,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            "t": 69,
                            "s": [
                                200,
                                200,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            "t": 91,
                            "s": [
                                158.814,
                                158.814,
                                100
                            ]
                        },
                        {
                            "t": 120.0000048877,
                            "s": [
                                148.814,
                                148.814,
                                100
                            ]
                        }
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 39,
            "ty": 2,
            "nm": "Solutions 2",
            "refId": "image_14",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1280,
                        1519.078,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        157,
                        49,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            "t": 33,
                            "s": [
                                164,
                                164,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            "t": 69,
                            "s": [
                                200,
                                200,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.833,
                                    0.833,
                                    0.833
                                ],
                                "y": [
                                    0.833,
                                    0.833,
                                    0.833
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0.167,
                                    0.167,
                                    0.167
                                ]
                            },
                            "t": 91,
                            "s": [
                                176,
                                176,
                                100
                            ]
                        },
                        {
                            "t": 120.0000048877,
                            "s": [
                                164,
                                164,
                                100
                            ]
                        }
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 457.000018613992,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 41,
            "ty": 4,
            "nm": "Shape Layer 5",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1280,
                        1440,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": {
                                "a": 0,
                                "k": [
                                    2560,
                                    2880
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "nm": "Rectangle Path 1",
                            "mn": "ADBE Vector Shape - Rect",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.065467064053,
                                    0.068664618099,
                                    0.129411645029,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Rectangle 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 611.00002488654,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": [],
    "chars": [
        {
            "ch": "C",
            "size": 25,
            "style": "Regular",
            "w": 72.73,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                1.752,
                                                2.924
                                            ],
                                            [
                                                2.604,
                                                2.048
                                            ],
                                            [
                                                3.232,
                                                1.065
                                            ],
                                            [
                                                3.669,
                                                0
                                            ],
                                            [
                                                4.83,
                                                -3.03
                                            ],
                                            [
                                                2.77,
                                                -5.587
                                            ],
                                            [
                                                0,
                                                -7.67
                                            ],
                                            [
                                                -2.77,
                                                -5.587
                                            ],
                                            [
                                                -4.83,
                                                -3.03
                                            ],
                                            [
                                                -6.203,
                                                0
                                            ],
                                            [
                                                -3.232,
                                                1.065
                                            ],
                                            [
                                                -2.605,
                                                2.048
                                            ],
                                            [
                                                -1.752,
                                                2.936
                                            ],
                                            [
                                                -0.663,
                                                3.717
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.29,
                                                -1.929
                                            ],
                                            [
                                                1.834,
                                                -1.314
                                            ],
                                            [
                                                2.225,
                                                -0.663
                                            ],
                                            [
                                                2.415,
                                                0
                                            ],
                                            [
                                                3.563,
                                                2.226
                                            ],
                                            [
                                                2.095,
                                                4.332
                                            ],
                                            [
                                                0,
                                                6.298
                                            ],
                                            [
                                                -2.095,
                                                4.332
                                            ],
                                            [
                                                -3.563,
                                                2.226
                                            ],
                                            [
                                                -4.403,
                                                0
                                            ],
                                            [
                                                -2.226,
                                                -0.663
                                            ],
                                            [
                                                -1.835,
                                                -1.314
                                            ],
                                            [
                                                -1.291,
                                                -1.918
                                            ],
                                            [
                                                -0.521,
                                                -2.533
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.752,
                                                -2.924
                                            ],
                                            [
                                                -2.605,
                                                -2.047
                                            ],
                                            [
                                                -3.232,
                                                -1.065
                                            ],
                                            [
                                                -6.203,
                                                0
                                            ],
                                            [
                                                -4.83,
                                                3.031
                                            ],
                                            [
                                                -2.77,
                                                5.587
                                            ],
                                            [
                                                0,
                                                7.67
                                            ],
                                            [
                                                2.77,
                                                5.587
                                            ],
                                            [
                                                4.83,
                                                3.031
                                            ],
                                            [
                                                3.669,
                                                0
                                            ],
                                            [
                                                3.232,
                                                -1.065
                                            ],
                                            [
                                                2.604,
                                                -2.047
                                            ],
                                            [
                                                1.752,
                                                -2.935
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.521,
                                                2.51
                                            ],
                                            [
                                                -1.291,
                                                1.93
                                            ],
                                            [
                                                -1.835,
                                                1.314
                                            ],
                                            [
                                                -2.226,
                                                0.663
                                            ],
                                            [
                                                -4.403,
                                                0
                                            ],
                                            [
                                                -3.563,
                                                -2.225
                                            ],
                                            [
                                                -2.095,
                                                -4.332
                                            ],
                                            [
                                                0,
                                                -6.297
                                            ],
                                            [
                                                2.095,
                                                -4.332
                                            ],
                                            [
                                                3.563,
                                                -2.225
                                            ],
                                            [
                                                2.415,
                                                0
                                            ],
                                            [
                                                2.225,
                                                0.663
                                            ],
                                            [
                                                1.834,
                                                1.314
                                            ],
                                            [
                                                1.29,
                                                1.918
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.663,
                                                -3.74
                                            ]
                                        ],
                                        "v": [
                                            [
                                                63.707,
                                                -59.996
                                            ],
                                            [
                                                57.173,
                                                -67.454
                                            ],
                                            [
                                                48.42,
                                                -72.124
                                            ],
                                            [
                                                38.068,
                                                -73.722
                                            ],
                                            [
                                                21.52,
                                                -69.176
                                            ],
                                            [
                                                10.121,
                                                -56.25
                                            ],
                                            [
                                                5.966,
                                                -36.364
                                            ],
                                            [
                                                10.121,
                                                -16.477
                                            ],
                                            [
                                                21.52,
                                                -3.551
                                            ],
                                            [
                                                38.068,
                                                0.994
                                            ],
                                            [
                                                48.42,
                                                -0.604
                                            ],
                                            [
                                                57.173,
                                                -5.273
                                            ],
                                            [
                                                63.707,
                                                -12.749
                                            ],
                                            [
                                                67.33,
                                                -22.727
                                            ],
                                            [
                                                58.523,
                                                -22.727
                                            ],
                                            [
                                                55.806,
                                                -16.069
                                            ],
                                            [
                                                51.119,
                                                -11.204
                                            ],
                                            [
                                                45.028,
                                                -8.239
                                            ],
                                            [
                                                38.068,
                                                -7.244
                                            ],
                                            [
                                                26.119,
                                                -10.582
                                            ],
                                            [
                                                17.631,
                                                -20.419
                                            ],
                                            [
                                                14.489,
                                                -36.364
                                            ],
                                            [
                                                17.631,
                                                -52.308
                                            ],
                                            [
                                                26.119,
                                                -62.145
                                            ],
                                            [
                                                38.068,
                                                -65.483
                                            ],
                                            [
                                                45.028,
                                                -64.489
                                            ],
                                            [
                                                51.119,
                                                -61.523
                                            ],
                                            [
                                                55.806,
                                                -56.676
                                            ],
                                            [
                                                58.523,
                                                -50
                                            ],
                                            [
                                                67.33,
                                                -50
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "C",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "C",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "L",
            "size": 25,
            "style": "Regular",
            "w": 56.25,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                51.42,
                                                0
                                            ],
                                            [
                                                51.42,
                                                -7.812
                                            ],
                                            [
                                                17.614,
                                                -7.812
                                            ],
                                            [
                                                17.614,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "L",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "L",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "O",
            "size": 25,
            "style": "Regular",
            "w": 76.14,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                2.77,
                                                5.587
                                            ],
                                            [
                                                4.83,
                                                3.031
                                            ],
                                            [
                                                6.202,
                                                0
                                            ],
                                            [
                                                4.83,
                                                -3.03
                                            ],
                                            [
                                                2.77,
                                                -5.587
                                            ],
                                            [
                                                0,
                                                -7.67
                                            ],
                                            [
                                                -2.77,
                                                -5.587
                                            ],
                                            [
                                                -4.83,
                                                -3.03
                                            ],
                                            [
                                                -6.203,
                                                0
                                            ],
                                            [
                                                -4.83,
                                                3.031
                                            ],
                                            [
                                                -2.77,
                                                5.587
                                            ],
                                            [
                                                0,
                                                7.67
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -2.77,
                                                -5.587
                                            ],
                                            [
                                                -4.83,
                                                -3.03
                                            ],
                                            [
                                                -6.203,
                                                0
                                            ],
                                            [
                                                -4.83,
                                                3.031
                                            ],
                                            [
                                                -2.77,
                                                5.587
                                            ],
                                            [
                                                0,
                                                7.67
                                            ],
                                            [
                                                2.77,
                                                5.587
                                            ],
                                            [
                                                4.83,
                                                3.031
                                            ],
                                            [
                                                6.202,
                                                0
                                            ],
                                            [
                                                4.83,
                                                -3.03
                                            ],
                                            [
                                                2.77,
                                                -5.587
                                            ],
                                            [
                                                0,
                                                -7.67
                                            ]
                                        ],
                                        "v": [
                                            [
                                                66.016,
                                                -56.25
                                            ],
                                            [
                                                54.616,
                                                -69.176
                                            ],
                                            [
                                                38.068,
                                                -73.722
                                            ],
                                            [
                                                21.52,
                                                -69.176
                                            ],
                                            [
                                                10.121,
                                                -56.25
                                            ],
                                            [
                                                5.966,
                                                -36.364
                                            ],
                                            [
                                                10.121,
                                                -16.477
                                            ],
                                            [
                                                21.52,
                                                -3.551
                                            ],
                                            [
                                                38.068,
                                                0.994
                                            ],
                                            [
                                                54.616,
                                                -3.551
                                            ],
                                            [
                                                66.016,
                                                -16.477
                                            ],
                                            [
                                                70.17,
                                                -36.364
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "O",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                2.095,
                                                -4.332
                                            ],
                                            [
                                                3.563,
                                                -2.225
                                            ],
                                            [
                                                4.403,
                                                0
                                            ],
                                            [
                                                3.563,
                                                2.226
                                            ],
                                            [
                                                2.095,
                                                4.332
                                            ],
                                            [
                                                0,
                                                6.298
                                            ],
                                            [
                                                -2.095,
                                                4.332
                                            ],
                                            [
                                                -3.563,
                                                2.226
                                            ],
                                            [
                                                -4.403,
                                                0
                                            ],
                                            [
                                                -3.563,
                                                -2.225
                                            ],
                                            [
                                                -2.095,
                                                -4.332
                                            ],
                                            [
                                                0,
                                                -6.297
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -2.095,
                                                4.332
                                            ],
                                            [
                                                -3.563,
                                                2.226
                                            ],
                                            [
                                                -4.403,
                                                0
                                            ],
                                            [
                                                -3.563,
                                                -2.225
                                            ],
                                            [
                                                -2.095,
                                                -4.332
                                            ],
                                            [
                                                0,
                                                -6.297
                                            ],
                                            [
                                                2.095,
                                                -4.332
                                            ],
                                            [
                                                3.563,
                                                -2.225
                                            ],
                                            [
                                                4.403,
                                                0
                                            ],
                                            [
                                                3.563,
                                                2.226
                                            ],
                                            [
                                                2.095,
                                                4.332
                                            ],
                                            [
                                                0,
                                                6.298
                                            ]
                                        ],
                                        "v": [
                                            [
                                                58.505,
                                                -20.419
                                            ],
                                            [
                                                50.018,
                                                -10.582
                                            ],
                                            [
                                                38.068,
                                                -7.244
                                            ],
                                            [
                                                26.119,
                                                -10.582
                                            ],
                                            [
                                                17.631,
                                                -20.419
                                            ],
                                            [
                                                14.489,
                                                -36.364
                                            ],
                                            [
                                                17.631,
                                                -52.308
                                            ],
                                            [
                                                26.119,
                                                -62.145
                                            ],
                                            [
                                                38.068,
                                                -65.483
                                            ],
                                            [
                                                50.018,
                                                -62.145
                                            ],
                                            [
                                                58.505,
                                                -52.308
                                            ],
                                            [
                                                61.648,
                                                -36.364
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "O",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "O",
                        "np": 5,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "U",
            "size": 25,
            "style": "Regular",
            "w": 74.15,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.55,
                                                -2.758
                                            ],
                                            [
                                                2.912,
                                                -1.574
                                            ],
                                            [
                                                4.048,
                                                0
                                            ],
                                            [
                                                2.9,
                                                1.575
                                            ],
                                            [
                                                1.562,
                                                2.758
                                            ],
                                            [
                                                0,
                                                3.551
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.332,
                                                -3.894
                                            ],
                                            [
                                                -4.238,
                                                -2.237
                                            ],
                                            [
                                                -5.706,
                                                0
                                            ],
                                            [
                                                -4.238,
                                                2.237
                                            ],
                                            [
                                                -2.332,
                                                3.895
                                            ],
                                            [
                                                0,
                                                4.972
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                3.551
                                            ],
                                            [
                                                -1.551,
                                                2.758
                                            ],
                                            [
                                                -2.912,
                                                1.575
                                            ],
                                            [
                                                -4.048,
                                                0
                                            ],
                                            [
                                                -2.9,
                                                -1.574
                                            ],
                                            [
                                                -1.562,
                                                -2.758
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.972
                                            ],
                                            [
                                                2.332,
                                                3.895
                                            ],
                                            [
                                                4.238,
                                                2.237
                                            ],
                                            [
                                                5.705,
                                                0
                                            ],
                                            [
                                                4.238,
                                                -2.237
                                            ],
                                            [
                                                2.332,
                                                -3.894
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                56.534,
                                                -25.284
                                            ],
                                            [
                                                54.208,
                                                -15.82
                                            ],
                                            [
                                                47.514,
                                                -9.322
                                            ],
                                            [
                                                37.074,
                                                -6.96
                                            ],
                                            [
                                                26.651,
                                                -9.322
                                            ],
                                            [
                                                19.957,
                                                -15.82
                                            ],
                                            [
                                                17.614,
                                                -25.284
                                            ],
                                            [
                                                17.614,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -24.574
                                            ],
                                            [
                                                12.305,
                                                -11.275
                                            ],
                                            [
                                                22.159,
                                                -2.077
                                            ],
                                            [
                                                37.074,
                                                1.278
                                            ],
                                            [
                                                51.989,
                                                -2.077
                                            ],
                                            [
                                                61.843,
                                                -11.275
                                            ],
                                            [
                                                65.341,
                                                -24.574
                                            ],
                                            [
                                                65.341,
                                                -72.727
                                            ],
                                            [
                                                56.534,
                                                -72.727
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "U",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "U",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "D",
            "size": 25,
            "style": "Regular",
            "w": 71.88,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                -5.161,
                                                2.924
                                            ],
                                            [
                                                -2.699,
                                                5.457
                                            ],
                                            [
                                                0,
                                                7.576
                                            ],
                                            [
                                                2.675,
                                                5.41
                                            ],
                                            [
                                                5.019,
                                                2.9
                                            ],
                                            [
                                                7.055,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                5.161,
                                                -2.924
                                            ],
                                            [
                                                2.699,
                                                -5.457
                                            ],
                                            [
                                                0,
                                                -7.528
                                            ],
                                            [
                                                -2.676,
                                                -5.409
                                            ],
                                            [
                                                -5.019,
                                                -2.9
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                7.386,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                50.071,
                                                -4.386
                                            ],
                                            [
                                                61.861,
                                                -16.957
                                            ],
                                            [
                                                65.909,
                                                -36.506
                                            ],
                                            [
                                                61.896,
                                                -55.913
                                            ],
                                            [
                                                50.355,
                                                -68.377
                                            ],
                                            [
                                                32.244,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ],
                                            [
                                                31.25,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "D",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.812,
                                                -2.284
                                            ],
                                            [
                                                -1.918,
                                                -4.249
                                            ],
                                            [
                                                0,
                                                -5.871
                                            ],
                                            [
                                                1.941,
                                                -4.285
                                            ],
                                            [
                                                3.953,
                                                -2.32
                                            ],
                                            [
                                                6.013,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.682,
                                                0
                                            ],
                                            [
                                                3.811,
                                                2.285
                                            ],
                                            [
                                                1.918,
                                                4.25
                                            ],
                                            [
                                                0,
                                                5.919
                                            ],
                                            [
                                                -1.941,
                                                4.285
                                            ],
                                            [
                                                -3.954,
                                                2.32
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.614,
                                                -64.915
                                            ],
                                            [
                                                31.676,
                                                -64.915
                                            ],
                                            [
                                                45.916,
                                                -61.488
                                            ],
                                            [
                                                54.51,
                                                -51.687
                                            ],
                                            [
                                                57.386,
                                                -36.506
                                            ],
                                            [
                                                54.474,
                                                -21.2
                                            ],
                                            [
                                                45.632,
                                                -11.293
                                            ],
                                            [
                                                30.682,
                                                -7.812
                                            ],
                                            [
                                                17.614,
                                                -7.812
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "D",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "D",
                        "np": 5,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": " ",
            "size": 25,
            "style": "Regular",
            "w": 28.12,
            "data": {},
            "fFamily": "Inter"
        },
        {
            "ch": "E",
            "size": 25,
            "style": "Regular",
            "w": 59.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                53.267,
                                                0
                                            ],
                                            [
                                                53.267,
                                                -7.812
                                            ],
                                            [
                                                17.614,
                                                -7.812
                                            ],
                                            [
                                                17.614,
                                                -32.528
                                            ],
                                            [
                                                50.426,
                                                -32.528
                                            ],
                                            [
                                                50.426,
                                                -40.341
                                            ],
                                            [
                                                17.614,
                                                -40.341
                                            ],
                                            [
                                                17.614,
                                                -64.915
                                            ],
                                            [
                                                52.699,
                                                -64.915
                                            ],
                                            [
                                                52.699,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "E",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "E",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "R",
            "size": 25,
            "style": "Regular",
            "w": 63.92,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.391,
                                                -1.195
                                            ],
                                            [
                                                -1.089,
                                                -2.178
                                            ],
                                            [
                                                0,
                                                -2.912
                                            ],
                                            [
                                                1.077,
                                                -2.095
                                            ],
                                            [
                                                2.379,
                                                -1.136
                                            ],
                                            [
                                                3.882,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.622,
                                                1.882
                                            ],
                                            [
                                                -1.752,
                                                3.315
                                            ],
                                            [
                                                0,
                                                4.285
                                            ],
                                            [
                                                1.752,
                                                3.362
                                            ],
                                            [
                                                3.645,
                                                1.93
                                            ],
                                            [
                                                5.682,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.93,
                                                0
                                            ],
                                            [
                                                2.391,
                                                1.196
                                            ],
                                            [
                                                1.089,
                                                2.178
                                            ],
                                            [
                                                0,
                                                2.912
                                            ],
                                            [
                                                -1.078,
                                                2.095
                                            ],
                                            [
                                                -2.379,
                                                1.136
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.634,
                                                0
                                            ],
                                            [
                                                3.622,
                                                -1.882
                                            ],
                                            [
                                                1.752,
                                                -3.314
                                            ],
                                            [
                                                0,
                                                -4.285
                                            ],
                                            [
                                                -1.752,
                                                -3.361
                                            ],
                                            [
                                                -3.646,
                                                -1.929
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.614,
                                                0
                                            ],
                                            [
                                                17.614,
                                                -64.915
                                            ],
                                            [
                                                33.097,
                                                -64.915
                                            ],
                                            [
                                                42.578,
                                                -63.121
                                            ],
                                            [
                                                47.798,
                                                -58.061
                                            ],
                                            [
                                                49.432,
                                                -50.426
                                            ],
                                            [
                                                47.816,
                                                -42.915
                                            ],
                                            [
                                                42.631,
                                                -38.068
                                            ],
                                            [
                                                33.239,
                                                -36.364
                                            ],
                                            [
                                                13.636,
                                                -36.364
                                            ],
                                            [
                                                13.636,
                                                -28.409
                                            ],
                                            [
                                                33.523,
                                                -28.409
                                            ],
                                            [
                                                47.408,
                                                -31.232
                                            ],
                                            [
                                                55.469,
                                                -39.027
                                            ],
                                            [
                                                58.097,
                                                -50.426
                                            ],
                                            [
                                                55.469,
                                                -61.896
                                            ],
                                            [
                                                47.372,
                                                -69.833
                                            ],
                                            [
                                                33.381,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "R",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                33.097,
                                                -32.67
                                            ],
                                            [
                                                50.71,
                                                0
                                            ],
                                            [
                                                60.938,
                                                0
                                            ],
                                            [
                                                43.04,
                                                -32.67
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "R",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "R",
                        "np": 5,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "T",
            "size": 25,
            "style": "Regular",
            "w": 64.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.699,
                                                -64.915
                                            ],
                                            [
                                                27.699,
                                                0
                                            ],
                                            [
                                                36.506,
                                                0
                                            ],
                                            [
                                                36.506,
                                                -64.915
                                            ],
                                            [
                                                59.375,
                                                -64.915
                                            ],
                                            [
                                                59.375,
                                                -72.727
                                            ],
                                            [
                                                4.83,
                                                -72.727
                                            ],
                                            [
                                                4.83,
                                                -64.915
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "T",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "T",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "I",
            "size": 25,
            "style": "Regular",
            "w": 26.42,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ],
                                            [
                                                17.614,
                                                0
                                            ],
                                            [
                                                17.614,
                                                -72.727
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "I",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "I",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "F",
            "size": 25,
            "style": "Regular",
            "w": 58.66,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.614,
                                                0
                                            ],
                                            [
                                                17.614,
                                                -32.528
                                            ],
                                            [
                                                49.148,
                                                -32.528
                                            ],
                                            [
                                                49.148,
                                                -40.341
                                            ],
                                            [
                                                17.614,
                                                -40.341
                                            ],
                                            [
                                                17.614,
                                                -64.915
                                            ],
                                            [
                                                52.415,
                                                -64.915
                                            ],
                                            [
                                                52.415,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "F",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "F",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "A",
            "size": 25,
            "style": "Regular",
            "w": 67.61,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                33.523,
                                                -61.222
                                            ],
                                            [
                                                34.091,
                                                -61.222
                                            ],
                                            [
                                                55.824,
                                                0
                                            ],
                                            [
                                                65.057,
                                                0
                                            ],
                                            [
                                                38.352,
                                                -72.727
                                            ],
                                            [
                                                29.261,
                                                -72.727
                                            ],
                                            [
                                                2.557,
                                                0
                                            ],
                                            [
                                                11.79,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "A",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                15.199,
                                                -20.597
                                            ],
                                            [
                                                52.415,
                                                -20.597
                                            ],
                                            [
                                                52.415,
                                                -28.409
                                            ],
                                            [
                                                15.199,
                                                -28.409
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "A",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "A",
                        "np": 5,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "N",
            "size": 25,
            "style": "Regular",
            "w": 75.28,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                57.812,
                                                -72.727
                                            ],
                                            [
                                                57.812,
                                                -15.483
                                            ],
                                            [
                                                57.102,
                                                -15.483
                                            ],
                                            [
                                                17.33,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ],
                                            [
                                                17.614,
                                                0
                                            ],
                                            [
                                                17.614,
                                                -57.102
                                            ],
                                            [
                                                18.324,
                                                -57.102
                                            ],
                                            [
                                                57.955,
                                                0
                                            ],
                                            [
                                                66.477,
                                                0
                                            ],
                                            [
                                                66.477,
                                                -72.727
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "N",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "N",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "V",
            "size": 25,
            "style": "Regular",
            "w": 67.61,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                2.557,
                                                -72.727
                                            ],
                                            [
                                                29.261,
                                                0
                                            ],
                                            [
                                                38.352,
                                                0
                                            ],
                                            [
                                                65.057,
                                                -72.727
                                            ],
                                            [
                                                55.824,
                                                -72.727
                                            ],
                                            [
                                                34.233,
                                                -11.506
                                            ],
                                            [
                                                33.381,
                                                -11.506
                                            ],
                                            [
                                                11.79,
                                                -72.727
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "V",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "V",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "J",
            "size": 25,
            "style": "Regular",
            "w": 54.26,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.935,
                                                -2.071
                                            ],
                                            [
                                                1.776,
                                                -1.065
                                            ],
                                            [
                                                2.533,
                                                0
                                            ],
                                            [
                                                1.799,
                                                0.852
                                            ],
                                            [
                                                1.03,
                                                1.527
                                            ],
                                            [
                                                0,
                                                2.06
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.776,
                                                -2.699
                                            ],
                                            [
                                                -3.102,
                                                -1.456
                                            ],
                                            [
                                                -3.977,
                                                0
                                            ],
                                            [
                                                -3.102,
                                                1.681
                                            ],
                                            [
                                                -1.705,
                                                3.244
                                            ],
                                            [
                                                0,
                                                4.64
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                3.007
                                            ],
                                            [
                                                -0.936,
                                                2.072
                                            ],
                                            [
                                                -1.776,
                                                1.065
                                            ],
                                            [
                                                -2.297,
                                                0
                                            ],
                                            [
                                                -1.799,
                                                -0.852
                                            ],
                                            [
                                                -1.03,
                                                -1.527
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.717
                                            ],
                                            [
                                                1.776,
                                                2.699
                                            ],
                                            [
                                                3.101,
                                                1.456
                                            ],
                                            [
                                                4.214,
                                                0
                                            ],
                                            [
                                                3.101,
                                                -1.681
                                            ],
                                            [
                                                1.705,
                                                -3.243
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                36.648,
                                                -20.739
                                            ],
                                            [
                                                35.245,
                                                -13.121
                                            ],
                                            [
                                                31.179,
                                                -8.416
                                            ],
                                            [
                                                24.716,
                                                -6.818
                                            ],
                                            [
                                                18.572,
                                                -8.097
                                            ],
                                            [
                                                14.329,
                                                -11.665
                                            ],
                                            [
                                                12.784,
                                                -17.045
                                            ],
                                            [
                                                4.119,
                                                -17.045
                                            ],
                                            [
                                                6.783,
                                                -7.422
                                            ],
                                            [
                                                14.098,
                                                -1.19
                                            ],
                                            [
                                                24.716,
                                                0.994
                                            ],
                                            [
                                                35.689,
                                                -1.527
                                            ],
                                            [
                                                42.898,
                                                -8.913
                                            ],
                                            [
                                                45.455,
                                                -20.739
                                            ],
                                            [
                                                45.455,
                                                -72.727
                                            ],
                                            [
                                                36.648,
                                                -72.727
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "J",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "J",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "B",
            "size": 25,
            "style": "Regular",
            "w": 65.06,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.575,
                                                1.705
                                            ],
                                            [
                                                -1.657,
                                                2.912
                                            ],
                                            [
                                                0,
                                                3.646
                                            ],
                                            [
                                                1.515,
                                                2.652
                                            ],
                                            [
                                                2.249,
                                                1.42
                                            ],
                                            [
                                                2.225,
                                                0.142
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.788,
                                                1.184
                                            ],
                                            [
                                                -1.101,
                                                2.036
                                            ],
                                            [
                                                0,
                                                3.125
                                            ],
                                            [
                                                1.61,
                                                2.924
                                            ],
                                            [
                                                3.29,
                                                1.74
                                            ],
                                            [
                                                5.066,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                5.729,
                                                0
                                            ],
                                            [
                                                3.574,
                                                -1.705
                                            ],
                                            [
                                                1.657,
                                                -2.912
                                            ],
                                            [
                                                0,
                                                -3.835
                                            ],
                                            [
                                                -1.515,
                                                -2.651
                                            ],
                                            [
                                                -2.249,
                                                -1.42
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.083,
                                                -0.568
                                            ],
                                            [
                                                1.787,
                                                -1.184
                                            ],
                                            [
                                                1.101,
                                                -2.036
                                            ],
                                            [
                                                0,
                                                -3.551
                                            ],
                                            [
                                                -1.61,
                                                -2.924
                                            ],
                                            [
                                                -3.291,
                                                -1.74
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                35.085,
                                                0
                                            ],
                                            [
                                                49.041,
                                                -2.557
                                            ],
                                            [
                                                56.889,
                                                -9.482
                                            ],
                                            [
                                                59.375,
                                                -19.318
                                            ],
                                            [
                                                57.102,
                                                -29.048
                                            ],
                                            [
                                                51.456,
                                                -35.156
                                            ],
                                            [
                                                44.744,
                                                -37.5
                                            ],
                                            [
                                                44.744,
                                                -38.21
                                            ],
                                            [
                                                50.55,
                                                -40.838
                                            ],
                                            [
                                                54.883,
                                                -45.668
                                            ],
                                            [
                                                56.534,
                                                -53.409
                                            ],
                                            [
                                                54.119,
                                                -63.121
                                            ],
                                            [
                                                46.768,
                                                -70.117
                                            ],
                                            [
                                                34.233,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "B",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.32,
                                                -1.266
                                            ],
                                            [
                                                -1.255,
                                                -2.095
                                            ],
                                            [
                                                0,
                                                -2.462
                                            ],
                                            [
                                                2.426,
                                                -2.237
                                            ],
                                            [
                                                5.753,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.172,
                                                0
                                            ],
                                            [
                                                2.32,
                                                1.267
                                            ],
                                            [
                                                1.255,
                                                2.095
                                            ],
                                            [
                                                0,
                                                3.196
                                            ],
                                            [
                                                -2.427,
                                                2.237
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.614,
                                                -33.097
                                            ],
                                            [
                                                35.511,
                                                -33.097
                                            ],
                                            [
                                                43.75,
                                                -31.197
                                            ],
                                            [
                                                49.112,
                                                -26.154
                                            ],
                                            [
                                                50.994,
                                                -19.318
                                            ],
                                            [
                                                47.354,
                                                -11.168
                                            ],
                                            [
                                                35.085,
                                                -7.812
                                            ],
                                            [
                                                17.614,
                                                -7.812
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "B",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 2,
                                "ty": "sh",
                                "ix": 3,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.226,
                                                -2.237
                                            ],
                                            [
                                                0,
                                                -3.196
                                            ],
                                            [
                                                1.266,
                                                -1.894
                                            ],
                                            [
                                                2.142,
                                                -1.041
                                            ],
                                            [
                                                2.651,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.83,
                                                0
                                            ],
                                            [
                                                2.225,
                                                2.237
                                            ],
                                            [
                                                0,
                                                2.557
                                            ],
                                            [
                                                -1.267,
                                                1.894
                                            ],
                                            [
                                                -2.143,
                                                1.042
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.614,
                                                -64.915
                                            ],
                                            [
                                                34.233,
                                                -64.915
                                            ],
                                            [
                                                44.815,
                                                -61.559
                                            ],
                                            [
                                                48.153,
                                                -53.409
                                            ],
                                            [
                                                46.254,
                                                -46.733
                                            ],
                                            [
                                                41.14,
                                                -42.33
                                            ],
                                            [
                                                33.949,
                                                -40.767
                                            ],
                                            [
                                                17.614,
                                                -40.767
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "B",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "B",
                        "np": 6,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "P",
            "size": 25,
            "style": "Regular",
            "w": 63.49,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.391,
                                                -1.314
                                            ],
                                            [
                                                -1.078,
                                                -2.296
                                            ],
                                            [
                                                0,
                                                -2.912
                                            ],
                                            [
                                                1.077,
                                                -2.308
                                            ],
                                            [
                                                2.367,
                                                -1.349
                                            ],
                                            [
                                                3.906,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.622,
                                                2.072
                                            ],
                                            [
                                                -1.74,
                                                3.504
                                            ],
                                            [
                                                0,
                                                4.285
                                            ],
                                            [
                                                1.752,
                                                3.48
                                            ],
                                            [
                                                3.634,
                                                2.048
                                            ],
                                            [
                                                5.705,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.953,
                                                0
                                            ],
                                            [
                                                2.391,
                                                1.314
                                            ],
                                            [
                                                1.077,
                                                2.297
                                            ],
                                            [
                                                0,
                                                2.912
                                            ],
                                            [
                                                -1.078,
                                                2.308
                                            ],
                                            [
                                                -2.368,
                                                1.349
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.658,
                                                0
                                            ],
                                            [
                                                3.622,
                                                -2.071
                                            ],
                                            [
                                                1.74,
                                                -3.503
                                            ],
                                            [
                                                0,
                                                -4.285
                                            ],
                                            [
                                                -1.752,
                                                -3.48
                                            ],
                                            [
                                                -3.634,
                                                -2.047
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.614,
                                                0
                                            ],
                                            [
                                                17.614,
                                                -64.915
                                            ],
                                            [
                                                33.097,
                                                -64.915
                                            ],
                                            [
                                                42.614,
                                                -62.944
                                            ],
                                            [
                                                47.816,
                                                -57.528
                                            ],
                                            [
                                                49.432,
                                                -49.716
                                            ],
                                            [
                                                47.816,
                                                -41.886
                                            ],
                                            [
                                                42.649,
                                                -36.399
                                            ],
                                            [
                                                33.239,
                                                -34.375
                                            ],
                                            [
                                                15.909,
                                                -34.375
                                            ],
                                            [
                                                15.909,
                                                -26.562
                                            ],
                                            [
                                                33.523,
                                                -26.562
                                            ],
                                            [
                                                47.443,
                                                -29.67
                                            ],
                                            [
                                                55.487,
                                                -38.033
                                            ],
                                            [
                                                58.097,
                                                -49.716
                                            ],
                                            [
                                                55.469,
                                                -61.364
                                            ],
                                            [
                                                47.39,
                                                -69.656
                                            ],
                                            [
                                                33.381,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "P",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "P",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "M",
            "size": 25,
            "style": "Regular",
            "w": 88.92,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                8.807,
                                                0
                                            ],
                                            [
                                                17.045,
                                                0
                                            ],
                                            [
                                                17.045,
                                                -55.256
                                            ],
                                            [
                                                17.756,
                                                -55.256
                                            ],
                                            [
                                                40.483,
                                                0
                                            ],
                                            [
                                                48.438,
                                                0
                                            ],
                                            [
                                                71.165,
                                                -55.256
                                            ],
                                            [
                                                71.875,
                                                -55.256
                                            ],
                                            [
                                                71.875,
                                                0
                                            ],
                                            [
                                                80.114,
                                                0
                                            ],
                                            [
                                                80.114,
                                                -72.727
                                            ],
                                            [
                                                69.602,
                                                -72.727
                                            ],
                                            [
                                                44.886,
                                                -12.358
                                            ],
                                            [
                                                44.034,
                                                -12.358
                                            ],
                                            [
                                                19.318,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "M",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "M",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "\r",
            "size": 25,
            "style": "Regular",
            "w": 0,
            "fFamily": "Inter"
        },
        {
            "ch": "S",
            "size": 25,
            "style": "Regular",
            "w": 63.78,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.142,
                                                2.889
                                            ],
                                            [
                                                3.645,
                                                1.669
                                            ],
                                            [
                                                4.688,
                                                0
                                            ],
                                            [
                                                3.752,
                                                -1.692
                                            ],
                                            [
                                                2.213,
                                                -3.042
                                            ],
                                            [
                                                0,
                                                -4.072
                                            ],
                                            [
                                                -3.315,
                                                -3.03
                                            ],
                                            [
                                                -5.682,
                                                -1.634
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.202,
                                                -0.947
                                            ],
                                            [
                                                -1.349,
                                                -1.515
                                            ],
                                            [
                                                0,
                                                -2.415
                                            ],
                                            [
                                                1.562,
                                                -1.976
                                            ],
                                            [
                                                2.675,
                                                -1.101
                                            ],
                                            [
                                                3.361,
                                                0
                                            ],
                                            [
                                                2.497,
                                                0.864
                                            ],
                                            [
                                                1.621,
                                                1.788
                                            ],
                                            [
                                                0.236,
                                                2.747
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.166,
                                                -3.006
                                            ],
                                            [
                                                -3.8,
                                                -1.681
                                            ],
                                            [
                                                -5.209,
                                                0
                                            ],
                                            [
                                                -3.918,
                                                1.87
                                            ],
                                            [
                                                -2.048,
                                                3.173
                                            ],
                                            [
                                                0,
                                                3.93
                                            ],
                                            [
                                                1.397,
                                                2.344
                                            ],
                                            [
                                                2.142,
                                                1.504
                                            ],
                                            [
                                                2.332,
                                                0.876
                                            ],
                                            [
                                                1.894,
                                                0.497
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.61,
                                                0.58
                                            ],
                                            [
                                                1.468,
                                                0.912
                                            ],
                                            [
                                                0.935,
                                                1.385
                                            ],
                                            [
                                                0,
                                                1.941
                                            ],
                                            [
                                                -1.338,
                                                1.823
                                            ],
                                            [
                                                -2.403,
                                                1.042
                                            ],
                                            [
                                                -3.22,
                                                0
                                            ],
                                            [
                                                -3.031,
                                                -1.989
                                            ],
                                            [
                                                -0.426,
                                                -3.598
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -0.119,
                                                -3.669
                                            ],
                                            [
                                                -2.143,
                                                -2.888
                                            ],
                                            [
                                                -3.646,
                                                -1.669
                                            ],
                                            [
                                                -4.64,
                                                0
                                            ],
                                            [
                                                -3.753,
                                                1.693
                                            ],
                                            [
                                                -2.214,
                                                3.042
                                            ],
                                            [
                                                0,
                                                4.901
                                            ],
                                            [
                                                3.314,
                                                3.031
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.557,
                                                0.71
                                            ],
                                            [
                                                2.202,
                                                0.947
                                            ],
                                            [
                                                1.349,
                                                1.515
                                            ],
                                            [
                                                0,
                                                2.652
                                            ],
                                            [
                                                -1.562,
                                                1.977
                                            ],
                                            [
                                                -2.676,
                                                1.101
                                            ],
                                            [
                                                -2.889,
                                                0
                                            ],
                                            [
                                                -2.498,
                                                -0.864
                                            ],
                                            [
                                                -1.622,
                                                -1.787
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.284,
                                                3.977
                                            ],
                                            [
                                                2.166,
                                                3.007
                                            ],
                                            [
                                                3.8,
                                                1.681
                                            ],
                                            [
                                                5.587,
                                                0
                                            ],
                                            [
                                                3.918,
                                                -1.87
                                            ],
                                            [
                                                2.047,
                                                -3.172
                                            ],
                                            [
                                                0,
                                                -3.409
                                            ],
                                            [
                                                -1.397,
                                                -2.344
                                            ],
                                            [
                                                -2.143,
                                                -1.503
                                            ],
                                            [
                                                -2.332,
                                                -0.876
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.349,
                                                -0.355
                                            ],
                                            [
                                                -1.61,
                                                -0.58
                                            ],
                                            [
                                                -1.468,
                                                -0.911
                                            ],
                                            [
                                                -0.936,
                                                -1.385
                                            ],
                                            [
                                                0,
                                                -2.32
                                            ],
                                            [
                                                1.337,
                                                -1.823
                                            ],
                                            [
                                                2.403,
                                                -1.041
                                            ],
                                            [
                                                4.403,
                                                0
                                            ],
                                            [
                                                3.03,
                                                1.989
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                57.102,
                                                -54.545
                                            ],
                                            [
                                                53.711,
                                                -64.382
                                            ],
                                            [
                                                45.028,
                                                -71.218
                                            ],
                                            [
                                                32.528,
                                                -73.722
                                            ],
                                            [
                                                19.94,
                                                -71.183
                                            ],
                                            [
                                                10.991,
                                                -64.08
                                            ],
                                            [
                                                7.67,
                                                -53.409
                                            ],
                                            [
                                                12.642,
                                                -41.513
                                            ],
                                            [
                                                26.136,
                                                -34.517
                                            ],
                                            [
                                                35.085,
                                                -31.96
                                            ],
                                            [
                                                42.223,
                                                -29.474
                                            ],
                                            [
                                                47.55,
                                                -25.781
                                            ],
                                            [
                                                49.574,
                                                -19.886
                                            ],
                                            [
                                                47.23,
                                                -12.944
                                            ],
                                            [
                                                40.874,
                                                -8.327
                                            ],
                                            [
                                                31.818,
                                                -6.676
                                            ],
                                            [
                                                23.739,
                                                -7.972
                                            ],
                                            [
                                                17.56,
                                                -11.95
                                            ],
                                            [
                                                14.773,
                                                -18.75
                                            ],
                                            [
                                                5.682,
                                                -18.75
                                            ],
                                            [
                                                9.357,
                                                -8.274
                                            ],
                                            [
                                                18.306,
                                                -1.243
                                            ],
                                            [
                                                31.818,
                                                1.278
                                            ],
                                            [
                                                46.076,
                                                -1.527
                                            ],
                                            [
                                                55.025,
                                                -9.091
                                            ],
                                            [
                                                58.097,
                                                -19.744
                                            ],
                                            [
                                                56.001,
                                                -28.374
                                            ],
                                            [
                                                50.692,
                                                -34.144
                                            ],
                                            [
                                                43.981,
                                                -37.713
                                            ],
                                            [
                                                37.642,
                                                -39.773
                                            ],
                                            [
                                                30.256,
                                                -41.761
                                            ],
                                            [
                                                25.817,
                                                -43.164
                                            ],
                                            [
                                                21.2,
                                                -45.401
                                            ],
                                            [
                                                17.596,
                                                -48.846
                                            ],
                                            [
                                                16.193,
                                                -53.835
                                            ],
                                            [
                                                18.2,
                                                -60.05
                                            ],
                                            [
                                                23.81,
                                                -64.347
                                            ],
                                            [
                                                32.244,
                                                -65.909
                                            ],
                                            [
                                                43.395,
                                                -62.926
                                            ],
                                            [
                                                48.58,
                                                -54.545
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "S",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "S",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "G",
            "size": 25,
            "style": "Regular",
            "w": 74.29,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.752,
                                                2.9
                                            ],
                                            [
                                                2.616,
                                                2.095
                                            ],
                                            [
                                                3.326,
                                                1.149
                                            ],
                                            [
                                                3.835,
                                                0
                                            ],
                                            [
                                                3.882,
                                                -1.728
                                            ],
                                            [
                                                2.841,
                                                -3.243
                                            ],
                                            [
                                                1.55,
                                                -4.604
                                            ],
                                            [
                                                0,
                                                -5.753
                                            ],
                                            [
                                                -2.711,
                                                -5.587
                                            ],
                                            [
                                                -4.865,
                                                -3.03
                                            ],
                                            [
                                                -6.44,
                                                0
                                            ],
                                            [
                                                -4.463,
                                                2.427
                                            ],
                                            [
                                                -2.545,
                                                4.427
                                            ],
                                            [
                                                0,
                                                5.99
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.787,
                                                -3.279
                                            ],
                                            [
                                                3.184,
                                                -1.787
                                            ],
                                            [
                                                4.166,
                                                0
                                            ],
                                            [
                                                3.598,
                                                2.226
                                            ],
                                            [
                                                2.107,
                                                4.332
                                            ],
                                            [
                                                0,
                                                6.298
                                            ],
                                            [
                                                -2.084,
                                                4.332
                                            ],
                                            [
                                                -3.528,
                                                2.226
                                            ],
                                            [
                                                -4.309,
                                                0
                                            ],
                                            [
                                                -2.202,
                                                -0.71
                                            ],
                                            [
                                                -1.74,
                                                -1.349
                                            ],
                                            [
                                                -1.267,
                                                -1.905
                                            ],
                                            [
                                                -0.781,
                                                -2.391
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -0.663,
                                                -3.527
                                            ],
                                            [
                                                -1.752,
                                                -2.9
                                            ],
                                            [
                                                -2.616,
                                                -2.095
                                            ],
                                            [
                                                -3.326,
                                                -1.148
                                            ],
                                            [
                                                -4.664,
                                                0
                                            ],
                                            [
                                                -3.883,
                                                1.728
                                            ],
                                            [
                                                -2.841,
                                                3.244
                                            ],
                                            [
                                                -1.551,
                                                4.605
                                            ],
                                            [
                                                0,
                                                7.67
                                            ],
                                            [
                                                2.711,
                                                5.587
                                            ],
                                            [
                                                4.865,
                                                3.031
                                            ],
                                            [
                                                5.776,
                                                0
                                            ],
                                            [
                                                4.462,
                                                -2.426
                                            ],
                                            [
                                                2.545,
                                                -4.427
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.451
                                            ],
                                            [
                                                -1.788,
                                                3.279
                                            ],
                                            [
                                                -3.184,
                                                1.788
                                            ],
                                            [
                                                -4.498,
                                                0
                                            ],
                                            [
                                                -3.599,
                                                -2.225
                                            ],
                                            [
                                                -2.107,
                                                -4.332
                                            ],
                                            [
                                                0,
                                                -6.297
                                            ],
                                            [
                                                2.083,
                                                -4.332
                                            ],
                                            [
                                                3.527,
                                                -2.225
                                            ],
                                            [
                                                2.628,
                                                0
                                            ],
                                            [
                                                2.202,
                                                0.71
                                            ],
                                            [
                                                1.74,
                                                1.349
                                            ],
                                            [
                                                1.266,
                                                1.906
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                67.614,
                                                -50
                                            ],
                                            [
                                                63.991,
                                                -59.641
                                            ],
                                            [
                                                57.44,
                                                -67.134
                                            ],
                                            [
                                                48.526,
                                                -71.999
                                            ],
                                            [
                                                37.784,
                                                -73.722
                                            ],
                                            [
                                                24.964,
                                                -71.129
                                            ],
                                            [
                                                14.879,
                                                -63.672
                                            ],
                                            [
                                                8.292,
                                                -51.9
                                            ],
                                            [
                                                5.966,
                                                -36.364
                                            ],
                                            [
                                                10.032,
                                                -16.477
                                            ],
                                            [
                                                21.396,
                                                -3.551
                                            ],
                                            [
                                                38.352,
                                                0.994
                                            ],
                                            [
                                                53.711,
                                                -2.646
                                            ],
                                            [
                                                64.222,
                                                -12.926
                                            ],
                                            [
                                                68.04,
                                                -28.551
                                            ],
                                            [
                                                68.04,
                                                -36.364
                                            ],
                                            [
                                                40.341,
                                                -36.364
                                            ],
                                            [
                                                40.341,
                                                -28.551
                                            ],
                                            [
                                                62.216,
                                                -28.551
                                            ],
                                            [
                                                59.517,
                                                -29.119
                                            ],
                                            [
                                                56.836,
                                                -17.525
                                            ],
                                            [
                                                49.379,
                                                -9.925
                                            ],
                                            [
                                                38.352,
                                                -7.244
                                            ],
                                            [
                                                26.207,
                                                -10.582
                                            ],
                                            [
                                                17.649,
                                                -20.419
                                            ],
                                            [
                                                14.489,
                                                -36.364
                                            ],
                                            [
                                                17.614,
                                                -52.308
                                            ],
                                            [
                                                26.03,
                                                -62.145
                                            ],
                                            [
                                                37.784,
                                                -65.483
                                            ],
                                            [
                                                45.028,
                                                -64.418
                                            ],
                                            [
                                                50.941,
                                                -61.328
                                            ],
                                            [
                                                55.451,
                                                -56.445
                                            ],
                                            [
                                                58.523,
                                                -50
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "G",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "G",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "Y",
            "size": 25,
            "style": "Regular",
            "w": 66.48,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                28.835,
                                                -29.972
                                            ],
                                            [
                                                28.835,
                                                0
                                            ],
                                            [
                                                37.642,
                                                0
                                            ],
                                            [
                                                37.642,
                                                -29.972
                                            ],
                                            [
                                                63.92,
                                                -72.727
                                            ],
                                            [
                                                53.835,
                                                -72.727
                                            ],
                                            [
                                                33.665,
                                                -38.778
                                            ],
                                            [
                                                32.812,
                                                -38.778
                                            ],
                                            [
                                                12.642,
                                                -72.727
                                            ],
                                            [
                                                2.557,
                                                -72.727
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "Y",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "Y",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        },
        {
            "ch": "H",
            "size": 25,
            "style": "Regular",
            "w": 74.01,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.614,
                                                0
                                            ],
                                            [
                                                17.614,
                                                -32.528
                                            ],
                                            [
                                                56.392,
                                                -32.528
                                            ],
                                            [
                                                56.392,
                                                0
                                            ],
                                            [
                                                65.199,
                                                0
                                            ],
                                            [
                                                65.199,
                                                -72.727
                                            ],
                                            [
                                                56.392,
                                                -72.727
                                            ],
                                            [
                                                56.392,
                                                -40.341
                                            ],
                                            [
                                                17.614,
                                                -40.341
                                            ],
                                            [
                                                17.614,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                -72.727
                                            ],
                                            [
                                                8.807,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "H",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "H",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Inter"
        }
    ]
}
